<template>
  <transition-group
    name="fade"
    tag="div"
    class="toast-container"
    :style="{ top: topPosition }"
  >
    <div
      v-for="toast in messages"
      :key="toast.id"
      class="toast-message"
      :class="toast.type"
      @click="onClickToast(toast)"
    >
      <p class="accent white toast-content">{{ toast.message }}</p>
    </div>
  </transition-group>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useToastStore } from '@/stores/toast.js';
import { IToastMessage } from '@/types/components';

withDefaults(
  defineProps<{
    topPosition?: string;
    bottomPosition?: string;
  }>(),
  {
    topPosition: '0.5rem',
    bottomPosition: '2.75rem',
  }
);

const toastStore = useToastStore();

// 토스트 메세지 목록
const messages = computed(() => toastStore.messages);

// 토스트 클릭 시 해당 토스트 제거
const onClickToast = (toast: IToastMessage) => {
  const messagesFiltered = toastStore.messages.filter(
    (toastItem: IToastMessage) => toastItem.seq !== toast.seq
  );
  toastStore.messages = messagesFiltered;
};
</script>

<style scoped lang="scss">
.toast-container {
  position: fixed;
  width: calc(100% - 2rem);
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;

  display: flex;
  flex-direction: column;
}

.toast-message {
  display: flex;
  width: fit-content;
  max-width: 70rem;
  margin-left: auto;
  margin-right: auto;
  gap: 0.25rem;
  padding: 1rem 1.25rem;
  margin-bottom: 0.25rem;
  border-radius: 4px;
  background-color: var(--surface-glass-darkest);
  backdrop-filter: blur(4px);
}

.toast-message.info {
  background-color: var(--surface-glass-darkest);
}

.toast-message.warn {
  background-color: var(--surface-glass-darkest);
}

.toast-message.error {
  background-color: var(--surface-glass-darkest);
}

.info-icon {
  position: relative;
  width: 1rem;
  height: 1rem;
  top: 0.25rem;
  fill: var(--color-white);
  flex-shrink: 0;
}

.toast-content {
  width: 100%;
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
  transform-origin: center center;
}

.fade-enter-from {
  opacity: 0;
  transform: scale(0.8);
}

.fade-enter-to {
  opacity: 1;
  transform: scale(1);
}

.fade-leave-from {
  opacity: 1;
  transform: scale(1);
}

.fade-leave-to {
  opacity: 0;
  transform: scale(0.8);
}
</style>
